import React, { useState, useEffect, useRef } from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const FlagImage = ({ countryCode }) => {
  const { t } = useLanguage();
  const [isLoading, setIsLoading] = useState(true);
  const [imageSrc, setImageSrc] = useState('');
  const [imageError, setImageError] = useState(false);
  const imageRef = useRef(null);

  useEffect(() => {
    // Paramètres de compression pour les drapeaux
    const quality = '85'; // Bonne qualité pour les drapeaux
    const width = '400'; // Largeur maximale pour les drapeaux
    
    // URL avec compression
    const compressedImageSrc = `/api/image/flags/${countryCode}/flag/flag.png?quality=${quality}&width=${width}`;
    
    // URL de fallback
    const fallbackImageSrc = `images/flags/${countryCode}/flag.png?t=${new Date().getTime()}`;
    
    setIsLoading(true);
    setImageError(false);
    
    const img = new Image();
    
    img.onload = () => {
      setImageSrc(compressedImageSrc);
      setIsLoading(false);
    };
    
    img.onerror = () => {
      // Essayer l'image de fallback
      const fallbackImg = new Image();
      
      fallbackImg.onload = () => {
        setImageSrc(fallbackImageSrc);
        setIsLoading(false);
      };
      
      fallbackImg.onerror = () => {
        setImageError(true);
        setIsLoading(false);
      };
      
      fallbackImg.src = fallbackImageSrc;
    };
    
    img.src = compressedImageSrc;
    
  }, [countryCode]);

  // Intersection Observer pour le lazy loading
  useEffect(() => {
    if (!imageRef.current) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('loaded');
          }
        });
      },
      { threshold: 0.1 }
    );

    observer.observe(imageRef.current);

    return () => {
      if (imageRef.current) {
        observer.unobserve(imageRef.current);
      }
    };
  }, []);

  return (
    <div className="flag-container" ref={imageRef}>
      {isLoading && <div className="loading"></div>}
      {!imageError ? (
        <img
          src={imageSrc}
          alt="Country Flag"
          className="flag-image"
          style={{ 
            opacity: isLoading ? 0.5 : 1,
            transition: 'opacity 0.3s ease'
          }}
          loading="lazy"
        />
      ) : (
        <div className="image-error">{t('flagNotFound')}</div>
      )}
    </div>
  );
};

export default FlagImage;